export default class BrandclubStoreConfigUtils {
  public static readonly stripeDebugMode = false;

  public static getAppStage(): 'localhost' | 'beta' | 'gamma' | 'prod' {
    const nodeEnv = import.meta.env?.MODE || process.env.NODE_ENV;

    if (nodeEnv === 'development') {
      return 'localhost';
    }

    const origin = window.location.origin;
    if (origin.includes('beta.brandclub') || origin.includes('-beta.') || origin.includes('beta-')) {
      return 'beta';
    }

    if (origin.includes('gamma.brandclub') || origin.includes('-gamma.') || origin.includes('gamma-')) {
      return 'gamma';
    }

    return 'prod';
  }

  public static getWebAppId() {
    return window.location.hostname;
  }

  public static getBaseDomain() {
    // Split the hostname into parts
    const parts = window.location.hostname.split('.');

    // If it's an IP address or a localhost, return the full hostname
    if (parts.length === 1 || parts[0] === 'localhost') {
      return window.location.hostname;
    }

    // Handle typical domains (like example.com) or complex domains (like example.co.uk)
    const topLevelDomainLength =
      parts[parts.length - 1].length === 2 && parts[parts.length - 2].length === 2
        ? 3 // handles two-level TLDs like co.uk
        : 2;

    // Slice to get the base domain
    return parts.slice(-topLevelDomainLength).join('.');
  }

  public static getApiHostName(): string {
    return `${window.location.origin}/api-rewards`;
  }

  public static getServerSideSyncHostName(): string {
    return `${window.location.origin}/api-retailer-sync`;
  }

  public static getGoogleMapsApiKey(): string {
    return 'AIzaSyDIvKiFNOD6JC_3ZXMeE4rtPVw49BFanJg';
  }

  public static getGoogleMapsMapId(): string {
    return '6b6881fc70e2cb88'; // Created in google cloud console
  }

  public static getEdgeCachedApiHostName(): string {
    return `${window.location.origin}/api-rewards`;
  }

  public static getGraphQlUri(): string {
    const base = this.getApiHostName();
    return `${base}/graphql`;
  }

  public static getStripePublishableKey(): string {
    const appStage = this.getAppStage();
    if (appStage === 'localhost' && this.stripeDebugMode) {
      return 'pk_test_51LnQyZJrInA7nkEZROUUcHyEsSs2CP3eWlIzOzIk6eMyGIKF8vsjZ4cGFjxrjZas6FlwTs2F9YvxrGsbdwojbxRO00IBijaZzD';
    }

    return 'pk_live_51LnQyZJrInA7nkEZJwYqka6fFt6Zz8m1V3l4hC2Rn3N3iLXCWgd8K3oQonZw3SWdpZoZ1UPogaw3kQwt5DyWnVXz00Mr9PFmjh';
  }

  public static getServerSideSyncGraphQlUri(): string {
    const base = this.getServerSideSyncHostName();

    return `${base}/graphql`;
  }
}
